import type { Action, Middleware } from '@reduxjs/toolkit';
import { isAction, isFulfilled, isRejectedWithValue } from '@reduxjs/toolkit';
import { RootState } from 'store';
import { apiRequestFailed, apiRequestSucceeded, isServiceUnavailableStatus } from 'store/reducers/apiStatus';

// ==============================|| MIDDLEWARE - API STATUS ||============================== //

export const apiStatusMiddleware: Middleware<object, RootState> = (store) => (next) => (action) => {
    const result = next(action);

    if (!isAction(action) || !(action as Action).type.startsWith('portalAPI/')) {
        return result;
    }

    if (isFulfilled(action)) {
        const state = store.getState();
        if (state.apiStatus.consecutiveFailures > 0) {
            store.dispatch(apiRequestSucceeded());
        }
    } else if (isRejectedWithValue(action)) {
        const payload = action.payload as { status?: number | string } | undefined;
        // A request that never reached the API and a maintenance/gateway response both mean
        // the API is not serving. Without the second case a maintenance window is invisible
        // to the downtime guard, because 503s resolve as ordinary rejected requests and the
        // user only sees an error toast per failing screen.
        if (payload?.status === 'FETCH_ERROR' || isServiceUnavailableStatus(payload?.status)) {
            store.dispatch(apiRequestFailed());
        }
    }

    return result;
};
